export default "__VITE_ASSET__BL0dLMfQ__"